<template>
    <div class="home-brand-box">
        <h2 class="title AvantGarde">BRAND INTRODUCTION</h2>
        <h3 class="title-cn YaSiRegular">品牌介绍</h3>
        <ul class="brand-list">
<!--            <router-link tag="li" to="/OverView?id=2&brand=1&ele=a1" class="brand-li a1">-->
            <a tag="li" href="https://www.simonli.com/" class="brand-li a1" target="_blank">
                <svg class="brand-circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.9 240.9"><path class="circle-line" fill="none" stroke="#006284" stroke-width=".75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M12.2 148.7c12.5 48.2 56.3 83.8 108.4 83.8 61.9 0 112-50.2 112-112s-50.2-112-112-112c-45.4 0-84.6 27.1-102.1 66"/><circle class="circle-point" fill="#cecece" cx="18.1" cy="75.1" r="1.9"/></svg>
                <svg class="brands" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 775.9 597.7"><path  fill="#231815" d="M133.7 368.9h12.9V459h-12.9zM272.3 368.9h12.2V459h-13v-70.1l-27.6 34.9h-2.4l-28-34.9V459h-12.9v-90.1H213l29.7 37zM373.7 379.9c-10.3 0-18.8 3.2-25.4 9.7-6.6 6.5-9.9 14.7-9.9 24.7 0 9.7 3.3 17.8 10 24.3 6.6 6.5 15 9.7 25 9.7s18.4-3.3 25.1-9.9c6.7-6.6 10.1-14.8 10.1-24.6 0-9.5-3.4-17.6-10.1-24.1-6.8-6.5-15-9.8-24.8-9.8m-.5-12.2c13.9 0 25.5 4.4 34.8 13.2 9.2 8.8 13.9 19.9 13.9 33.1 0 13.3-4.7 24.3-14 33s-21.1 13.1-35.3 13.1c-13.6 0-24.9-4.3-33.9-13.1-9-8.7-13.6-19.6-13.6-32.7 0-13.5 4.5-24.6 13.7-33.4 9-8.8 20.5-13.2 34.4-13.2M527.8 368.9H540V459h-11l-60.3-69.4V459h-12.1v-90.1H467l60.8 70zM635.3 368.9h13v78.4h40.5V459h-53.5zM731.9 368.9h12.9V459h-12.9zM58.9 421.2l-9.8-6c-6.2-3.8-10.5-7.5-13.1-11.1-2.6-3.6-3.9-7.8-3.9-12.6 0-7.1 2.5-12.9 7.4-17.3s11.3-6.6 19.2-6.6c7.5 0 14.4 2.1 20.7 6.4v14.6c-6.5-6.3-13.5-9.4-21-9.4-4.2 0-7.7 1-10.4 2.9-2.7 2-4.1 4.5-4.1 7.5 0 2.7 1 5.2 3 7.6 2 2.4 5.2 4.8 9.7 7.4l9.9 5.8c11 6.6 16.5 15 16.5 25.1 0 7.2-2.4 13.1-7.3 17.6-4.8 4.5-11.1 6.8-18.9 6.8-8.9 0-17-2.8-24.3-8.3v-16.4c7 8.8 15 13.2 24.2 13.2 4 0 7.4-1.1 10.1-3.4 2.7-2.3 4-5.1 4-8.5 0-5.2-4-10.4-11.9-15.3M33.7 522.3h26.1v6.4H40.7v13.6h19.1v6.3H40.7v22.8h-7zM146.3 522.3h7v27.9c0 3.8-.3 6.6-.8 8.6-.5 1.9-1.2 3.5-2 4.8-.8 1.3-1.8 2.4-3 3.4-3.9 3.3-9 5-15.3 5-6.4 0-11.5-1.7-15.4-5-1.2-1.1-2.2-2.2-3-3.5-.8-1.3-1.5-2.8-2-4.7-.5-1.9-.8-4.8-.8-8.7v-27.8h7v27.9c0 4.6.5 7.8 1.6 9.6 1.1 1.8 2.7 3.3 4.8 4.3 2.2 1.1 4.7 1.6 7.7 1.6 4.2 0 7.6-1.1 10.2-3.3 1.4-1.2 2.4-2.6 3-4.2.6-1.6.9-4.3.9-8.2v-27.7zM217.1 528.4H215v15.3h2.7c3.6 0 6-.3 7.3-.9 1.3-.6 2.4-1.5 3.1-2.7.7-1.2 1.1-2.6 1.1-4.1 0-1.5-.4-2.9-1.2-4.1-.8-1.2-2-2.1-3.5-2.6-1.5-.7-3.9-.9-7.4-.9m-9.1 43v-49h12.3c5 0 8.9 1.2 11.8 3.7 2.9 2.4 4.4 5.8 4.4 9.9 0 2.9-.7 5.3-2.2 7.4-1.4 2.1-3.5 3.6-6.2 4.7 1.6 1 3.1 2.4 4.7 4.2 1.5 1.8 3.6 4.9 6.4 9.3 1.7 2.8 3.1 4.9 4.1 6.3l2.6 3.5h-8.4l-2.1-3.3c-.1-.1-.2-.3-.4-.6l-1.4-1.9-2.2-3.6-2.3-3.8c-1.5-2-2.8-3.6-4-4.8-1.2-1.2-2.3-2-3.3-2.6-1-.5-2.6-.8-4.9-.8H215v21.4h-7zM330.5 522.3h6.8v49.1h-6.1l-32.8-37.8v37.8h-6.6v-49.1h5.7l33 38.1zM392.6 522.3h7v49h-7zM448.9 522.3h41v6.4h-17.2v42.7h-7v-42.7h-16.8zM570.9 522.3h7v27.9c0 3.8-.3 6.6-.8 8.6-.6 1.9-1.2 3.5-2 4.8-.8 1.3-1.8 2.4-3 3.4-3.9 3.3-9 5-15.3 5-6.4 0-11.5-1.7-15.4-5-1.2-1.1-2.2-2.2-3-3.5-.8-1.3-1.5-2.8-2-4.7-.5-1.9-.8-4.8-.8-8.7v-27.8h7v27.9c0 4.6.5 7.8 1.6 9.6 1.1 1.8 2.7 3.3 4.8 4.3 2.2 1.1 4.7 1.6 7.7 1.6 4.2 0 7.6-1.1 10.2-3.3 1.4-1.2 2.4-2.6 3-4.2.6-1.6.9-4.3.9-8.2v-27.7zM639.5 528.4h-2.1v15.3h2.7c3.6 0 6-.3 7.3-.9 1.3-.6 2.4-1.5 3.1-2.7.7-1.2 1.1-2.6 1.1-4.1 0-1.5-.4-2.9-1.2-4.1-.8-1.2-2-2.1-3.5-2.6-1.5-.7-3.9-.9-7.4-.9m-9.1 43v-49h12.3c5 0 8.9 1.2 11.8 3.7 2.9 2.4 4.4 5.8 4.4 9.9 0 2.9-.7 5.3-2.2 7.4-1.4 2.1-3.5 3.6-6.2 4.7 1.6 1 3.1 2.4 4.7 4.2 1.5 1.8 3.6 4.9 6.4 9.3 1.7 2.8 3.1 4.9 4.1 6.3l2.6 3.5H660l-2.1-3.3c-.1-.1-.2-.3-.4-.6l-1.4-1.9-2.2-3.6-2.3-3.8c-1.5-2-2.8-3.6-4-4.8-1.2-1.2-2.3-2-3.3-2.6-1-.5-2.6-.8-4.9-.8h-1.8v21.4h-7.2zM716.2 522.3H744v6.4h-20.7v14.8h20v6.4h-20V565h21.4v6.4h-28.5zM33.7 489.8h711v1.6h-711z"></path><path data-v-2f48a50e="" fill="#F48023" d="M532.2 177.2c0 7.6-6.2 13.8-13.8 13.8h-33.6c-7.6 0-13.8-6.2-13.8-13.8V36.8c0-7.6 6.2-13.8 13.8-13.8h33.6c7.6 0 13.8 6.2 13.8 13.8v140.4z"></path><path data-v-2f48a50e="" fill="#D8531D" d="M372.8 123.2c0-11.4 9.3-20.7 20.7-20.7h49.8c7.6 0 13.8-6.2 13.8-13.8V36.8c0-7.6-6.2-13.8-13.8-13.8h-106c-7.6 0-13.8 6.2-13.8 13.8v44.9c0 11.4-9.3 20.7-20.7 20.7h-38.9c-7.6 0-13.8 6.2-13.8 13.8V177c0 7.6 6.2 13.8 13.8 13.8H359c7.6 0 13.8-6.2 13.8-13.8v-53.8z"></path><path data-v-2f48a50e="" fill="#D8531D" d="M457.1 130.1c0-7.6-6.2-13.8-13.8-13.8h-42.1c-7.6 0-13.8 6.2-13.8 13.8v135c0 7.2 5.4 13 12.4 13.7.5 0 .9.1 1.4.1h117.2c7.6 0 13.8-6.2 13.8-13.8v-46.4c0-7.6-6.2-13.8-13.8-13.8h-40.6c-11.4 0-20.7-9.3-20.7-20.7v-54.1z"></path><path data-v-2f48a50e="" fill="#F48023" d="M372.8 218.6c0-7.6-6.2-13.8-13.8-13.8h-95.2c-7.6 0-13.8 6.2-13.8 13.8v46.5c0 7.6 6.2 13.8 13.8 13.8H359c7.6 0 13.8-6.2 13.8-13.8v-46.5zM309.7 36.8c0-7.6-6.2-13.8-13.8-13.8h-32.1c-7.6 0-13.8 6.2-13.8 13.8v38.1c0 7.6 6.2 13.8 13.8 13.8h32.1c7.6 0 13.8-6.2 13.8-13.8V36.8z"></path></svg>
            </a>
<!--            </router-link>-->
            <a tag="li" href="http://www.nestspace.com/" class="brand-li a1" target="_blank">
                <svg class="brand-circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.9 240.9"><path class="circle-line" fill="none" stroke="#006284" stroke-width=".75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M12.2 148.7c12.5 48.2 56.3 83.8 108.4 83.8 61.9 0 112-50.2 112-112s-50.2-112-112-112c-45.4 0-84.6 27.1-102.1 66"/><circle class="circle-point" fill="#cecece" cx="18.1" cy="75.1" r="1.9"/></svg>
                <img class="brands brands-2"  src="../../../assets/images/next_log.png" alt="">
            </a>
            <a tag="li" href="http://www.serenelivingspace.com/" class="brand-li a1" target="_blank">
                <svg class="brand-circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.9 240.9"><path class="circle-line" fill="none" stroke="#006284" stroke-width=".75" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M12.2 148.7c12.5 48.2 56.3 83.8 108.4 83.8 61.9 0 112-50.2 112-112s-50.2-112-112-112c-45.4 0-84.6 27.1-102.1 66"/><circle class="circle-point" fill="#cecece" cx="18.1" cy="75.1" r="1.9"/></svg>
                <img class="brands" src="../../../assets/images/serene_logo.png" alt="">
            </a>
<!--            <router-link tag="li" to="/OverView?id=2&brand=2&ele=a2" class="brand-li a1">-->
<!--                -->
<!--            </router-link>-->
<!--            <router-link tag="li" to="/OverView?id=2&brand=3&ele=a3" class="brand-li a1">-->
<!--            </router-link>-->
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'HomeBrand'
    }
</script>

<style lang="scss" scoped>
@use 'styles/common' as *;
.home-brand-box {
    margin: 30rem 0;
    opacity: 0;
}
.title {
    text-align: center;
}
.title-cn {
    margin: 1.5rem 0 5rem 0;
    text-align: center;
    letter-spacing: 1rem;
}
.brand-list {
    display: flex;
    justify-content: space-around;
    margin: 0 auto 0;
    /*width: 80%;*/
    width: 72%;
}
.brand-list {
    margin-top: 20rem;
}
//.brand-list li {
.brand-list a {
    position: relative;
    width: 21.25%;
}
.brand-list li:nth-of-type(n+2) {
    margin: 0 0 0 5%;
}
.brands {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 60%;
}
.brands-2 {
  top: 2vw;width: 55%;
  @include respond-to() {
    top: 4vw;
  }
}
.brand-circle {
    width: 100%;
    transition: all 10s linear;
}
.brand-li:hover .circle-line
{
    stroke-width: 3;
    stroke: #006284;
}
.brand-li:hover .circle-point {
    fill: #006284;
    r: 3.8;
}
.brand-li:hover .brand-circle {
    animation: turnRight 10s linear infinite;
}
.animate {
    animation: opacityIn 1s linear forwards;
}
@for $i from 1 through 6
{
    .a#{$i}
    {
        opacity: 0;
    }
}
@for $i from 1 through 6
{
    .animate .a#{$i}
    {
        animation: opacityIn 1s #{500 + 200 * $i}ms linear forwards;
    }
}
@media screen and (max-width: 1440px) {
    .home-brand {
        display: block;
        margin: 30rem auto 0;
        width: 40%;
    }
    .brand-list {
        margin-top: 10rem;
    }
}
@media screen and (max-width: 1024px) {
    .home-brand-box {
        margin: 10rem 0 0 0;
    }
    .brand-list {
        width: 90%;
    }
}
@media screen and (max-width: 750px) {
    .brand-list {
        margin-top: 5rem;
    }
    .brand-list li:nth-of-type(n+2) {
        margin: 0 0 0 1%;
    }
    .brand-list li {
        width: 24.25%;
    }
}
@media screen and (max-width: 500px) {
    .home-brand-box {
        margin: 5rem 0 0 0;
    }
}
</style>
